import { render } from "./LinkComTransacao.vue?vue&type=template&id=5a3d3838"
import script from "./LinkComTransacao.vue?vue&type=script&lang=js"
export * from "./LinkComTransacao.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Desenvolvimento\\projetos\\web\\cliqx.checkout.frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__